"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scaleIdentity = scaleIdentity;
function scaleIdentity() {
  var unknown;
  function scale(x) {
    return x === null ? unknown : x;
  }
  scale.invert = scale;
  scale.domain = scale.range = scaleIdentity;
  scale.unknown = function (u) {
    if (u) {
      unknown = u;
    }
    return scale;
  };
  return scale;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzY2FsZUlkZW50aXR5IiwidW5rbm93biIsInNjYWxlIiwieCIsImludmVydCIsImRvbWFpbiIsInJhbmdlIiwidSJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9jdXN0b20tc2NhbGVzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBzY2FsZUlkZW50aXR5KCkge1xuICBsZXQgdW5rbm93bjtcbiAgZnVuY3Rpb24gc2NhbGUoeCkge1xuICAgIHJldHVybiB4ID09PSBudWxsID8gdW5rbm93biA6IHg7XG4gIH1cblxuICBzY2FsZS5pbnZlcnQgPSBzY2FsZTtcblxuICBzY2FsZS5kb21haW4gPSBzY2FsZS5yYW5nZSA9IHNjYWxlSWRlbnRpdHk7XG5cbiAgc2NhbGUudW5rbm93biA9IHUgPT4ge1xuICAgIGlmICh1KSB7XG4gICAgICB1bmtub3duID0gdTtcbiAgICB9XG5cbiAgICByZXR1cm4gc2NhbGU7XG4gIH07XG5cbiAgcmV0dXJuIHNjYWxlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBTyxTQUFTQSxhQUFhQSxDQUFBLEVBQUc7RUFDOUIsSUFBSUMsT0FBTztFQUNYLFNBQVNDLEtBQUtBLENBQUNDLENBQUMsRUFBRTtJQUNoQixPQUFPQSxDQUFDLEtBQUssSUFBSSxHQUFHRixPQUFPLEdBQUdFLENBQUM7RUFDakM7RUFFQUQsS0FBSyxDQUFDRSxNQUFNLEdBQUdGLEtBQUs7RUFFcEJBLEtBQUssQ0FBQ0csTUFBTSxHQUFHSCxLQUFLLENBQUNJLEtBQUssR0FBR04sYUFBYTtFQUUxQ0UsS0FBSyxDQUFDRCxPQUFPLEdBQUcsVUFBQU0sQ0FBQyxFQUFJO0lBQ25CLElBQUlBLENBQUMsRUFBRTtNQUNMTixPQUFPLEdBQUdNLENBQUM7SUFDYjtJQUVBLE9BQU9MLEtBQUs7RUFDZCxDQUFDO0VBRUQsT0FBT0EsS0FBSztBQUNkIiwiaWdub3JlTGlzdCI6W119